import { render, staticRenderFns } from "./FaturaPaga.vue?vue&type=template&id=35031a48&scoped=true"
import script from "./FaturaPaga.vue?vue&type=script&lang=js"
export * from "./FaturaPaga.vue?vue&type=script&lang=js"
import style0 from "./FaturaPaga.vue?vue&type=style&index=0&id=35031a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35031a48",
  null
  
)

export default component.exports